import { ApiBillingInfo } from "Types/Billing/Api"
import { BillingInfo } from "Types/Billing/App"

const parseFreelancer = (cpfcnpj: string): boolean => {
  const unmaskedNumber = cpfcnpj.replace(/(\D)(?=\w)/g, '')

  return unmaskedNumber.length > 0 && unmaskedNumber.length <= 11
}

export const parseBillingInfo = (data: ApiBillingInfo): BillingInfo => {
  return {
    name: data.name,
    email: data.email,
    freelancer: (data.cnpJ_CPF, parseFreelancer(data.cnpJ_CPF)),
    cpfcnpj: data.cnpJ_CPF,
    phone: {
      ddd: data.ddd,
      number: (data.phoneNumber, data.phoneNumber.replace('-', '')),
    },
    location: {
      city: data.cityId,
      neighborhood: data.neighborhood,
      state: data.stateId,
      street: data.street,
      streetDetails: data.complementary,
      streetNumber: data.streetNumber,
      zipcode: data.zipCode,
    }
  }
}

export default {
  parseBillingInfo,
}